import lambdaApi from 'api/LambdaApi';
import { AxiosError } from 'axios';
import { CustomerWithReference } from 'generated-types/skills/customer_references';
import { useMutation } from 'react-query';

interface UseGenerateSlidesReturn {
    generateSlides: (
        newReferenceData: CustomerWithReference[],
        options?: {
            onSuccess?: (filename: string) => void;
            onError?: (error: AxiosError) => void;
        },
    ) => void;
    isGenerateSlidesLoading: boolean;
    isGenerateSlidesError: boolean;
}

const useGenerateSlidesHook = (): UseGenerateSlidesReturn => {
    const mutation = useMutation<string, AxiosError, CustomerWithReference[]>({
        mutationFn: async (referenceData: CustomerWithReference[]) => {
            const referencesUri = `/skills/customer-references/generate_slides/`;
            const res = await lambdaApi.post<string>(referencesUri, referenceData);
            return res.data;
        },
    });

    return {
        generateSlides: (newReferenceData, options) =>
            mutation.mutate(newReferenceData, {
                onSuccess: options?.onSuccess,
                onError: options?.onError,
            }),
        isGenerateSlidesLoading: mutation.isLoading,
        isGenerateSlidesError: mutation.isError,
    };
};

export { useGenerateSlidesHook };
